import { useReferenceState } from "lib/@hooks/use-reference"
import { AuthoringHideUnchangedToggle } from "authoring/components/authoring-hide-unchanged-toggle"

// Self-contained, persisted toggle - storageKey is caller-built so this works for both the
// work-package view (keyed by draftId) and the publishing preview dialog (keyed by snapshot id).
export function ScheduleCommentaryHideUnchangedToggle({ storageKey, dataCy = "hide-unchanged-sections-toggle" }) {
    const [hideUnchanged, setHideUnchanged] = useReferenceState(storageKey, false)

    return (
        <AuthoringHideUnchangedToggle
            hidden={hideUnchanged}
            onToggle={() => setHideUnchanged(!hideUnchanged)}
            dataCy={dataCy}
        />
    )
}
